import React, { useState } from "react";
import PropTypes from "prop-types";

import EmbeddedFrame from "./EmbeddedFrame";
import { getYouTubeThumbnail, isYoutubeUrl } from "../utils/utils";

import PlayIcon from "../images/icons/play.svg";

import "../styles/components/LazyVideoEmbed.scss";

const LazyVideoEmbed = ({ url, title = "Shiftmed video" }) => {
    const [playVideo, setPlayVideo] = useState(false);
    const isYoutubeVideo = isYoutubeUrl(url);

    if (isYoutubeVideo && !playVideo) {
        return (
            <button
                className="thumbnail"
                onClick={() => setPlayVideo(true)}
                aria-label="Play"
            >
                <picture>
                    <source
                        type="image/webp"
                        srcSet={getYouTubeThumbnail(url, "webp")}
                    ></source>
                    <img
                        className="image-rounded mw-100"
                        src={getYouTubeThumbnail(url)}
                        alt="Preview"
                    />
                </picture>
                <PlayIcon className="play-icon" />
            </button>
        );
    }

    return <EmbeddedFrame embeddedMediaUrl={url} title={title} />;
};

LazyVideoEmbed.propTypes = {
    url: PropTypes.string.isRequired,
    title: PropTypes.string,
};

export default LazyVideoEmbed;
